// Indonesian texts for the app shell, shared components, Overview and Domains pages.
export default {
  // formatting / shared components
  "in a moment": "sebentar lagi",
  "just now": "baru saja",
  "less than a minute": "kurang dari 1 menit",
  "{m} min": "{m} menit",
  "{h} h {m} min": "{h} jam {m} menit",
  "{h} h": "{h} jam",
  "{done} of {total}": "{done} dari {total}",
  "{n} processed": "{n} diproses",
  "Starting…": "Memulai…",
  "{n} failed": "{n} gagal",
  "Loading…": "Memuat…",
  "Try again": "Coba lagi",
  "1 item": "1 item",
  "{n} items": "{n} item",
  "Previous": "Sebelumnya",
  "Page {page} of {pages}": "Halaman {page} dari {pages}",
  "Next": "Berikutnya",
  "What does this mean?": "Apa artinya?",

  // status badges
  "Queued": "Mengantre",
  "Running": "Berjalan",
  "Paused": "Dijeda",
  "Completed": "Selesai",
  "Failed": "Gagal",
  "Cancelled": "Dibatalkan",
  "Not analyzed": "Belum dianalisis",
  "Analyzing": "Menganalisis",
  "Ready to recover": "Siap dipulihkan",
  "Recovering": "Memulihkan",
  "Recovered": "Sudah dipulihkan",
  "Needs attention": "Perlu perhatian",
  "Pending": "Menunggu",
  "Downloaded": "Terunduh",
  "Not archived": "Tidak diarsipkan",
  "Skipped": "Dilewati",
  "Spam – excluded": "Spam – dibuang",
  "OK": "OK",
  "Not checked": "Belum dicek",
  "Partial": "Sebagian",
  "Dynamic feature": "Fitur dinamis",

  // app shell
  "Checking session…": "Memeriksa sesi…",
  "Cannot reach the API": "Server panel tidak bisa dihubungi",
  "Recovery jobs already queued keep running in the background workers.": "Proses pemulihan yang sudah mengantre tetap berjalan di server.",
  "Retry": "Coba lagi",
  "Loading page…": "Memuat halaman…",
  "Page not found": "Halaman tidak ditemukan",
  "This page does not exist.": "Halaman ini tidak ada.",
  "Language": "Bahasa",
  "Wayback restoration": "Pemulihan dari Wayback",
  "Close menu": "Tutup menu",
  "Open menu": "Buka menu",
  "Overview": "Ringkasan",
  "Domains": "Domain",
  "Jobs": "Proses",
  "Settings": "Pengaturan",
  "Connecting…": "Menghubungkan…",
  "No jobs running": "Tidak ada proses berjalan",
  "{n} job in progress": "{n} proses berjalan",
  "{n} jobs in progress": "{n} proses berjalan",
  "Jobs keep running when you close this page.": "Proses tetap berjalan walau halaman ini ditutup.",
  "Toggle theme": "Ganti tema",
  "Light theme": "Tema terang",
  "Dark theme": "Tema gelap",
  "Sign out": "Keluar",

  // overview
  "Resumed from where it stopped": "Dilanjutkan dari titik terakhir",
  "Nothing needs your attention": "Tidak ada yang perlu ditangani",
  "No files about to be deleted, no failed jobs, no risky domains.": "Tidak ada file yang akan terhapus, proses gagal, atau domain berisiko.",
  "Things to do now, most urgent first.": "Hal yang perlu dikerjakan sekarang, paling mendesak di atas.",
  "Files are deleted from the server in {time}. Download the ZIP to keep the website.": "File dihapus dari server dalam {time}. Unduh ZIP supaya website tidak hilang.",
  "Download ZIP": "Unduh ZIP",
  "Job {id}": "Proses {id}",
  "Analysis": "Analisis",
  "Recovery": "Pemulihan",
  "{type} is paused": "{type} sedang dijeda",
  "{type} failed": "{type} gagal",
  "Resume": "Lanjutkan",
  "Open": "Buka",
  "Spam content (gambling / adult / pharma)": "Konten spam (judi / dewasa / obat)",
  "Many spam URLs": "Banyak URL spam",
  "Parked / for-sale page": "Halaman parkir / dijual",
  "Risky period detected": "Ada periode berisiko",
  "every period has warnings, check the screenshots": "semua periode punya peringatan, cek screenshot-nya",
  "Review": "Periksa",
  "{name} added — analysis started": "{name} ditambahkan — analisis dimulai",
  "Restore aged domains from the Internet Archive in three steps: analyze, choose a snapshot, recover.": "Pulihkan aged domain dari Internet Archive dalam tiga langkah: analisis, pilih snapshot, pulihkan.",
  "Recover a domain": "Pulihkan domain",
  "Enter a domain to analyze its archive history. Nothing is downloaded until you start a recovery.": "Masukkan domain untuk menganalisis riwayat arsipnya. Belum ada yang diunduh sampai pemulihan dimulai.",
  "Analyze a domain": "Analisis domain",
  "Analyze Domain": "Analisis Domain",
  "Have a list? Add many domains at once": "Punya daftar? Tambahkan banyak domain sekaligus",
  "View all": "Lihat semua",
  "In progress": "Sedang berjalan",
  "{n} paused": "{n} dijeda",
  "Running in the background": "Berjalan di latar belakang",
  "Completed jobs": "Proses selesai",
  "Server disk in use: {size}": "Disk server terpakai: {size}",
  "Need attention": "Perlu perhatian",
  "See the list above": "Lihat daftar di atas",
  "All good": "Semua aman",
  "All jobs": "Semua proses",
  "Nothing running": "Tidak ada yang berjalan",
  "Jobs run on the server, so you can close this page at any time.": "Proses berjalan di server, jadi halaman ini boleh ditutup kapan saja.",
  "Waiting": "Menunggu",
  "about {time} left": "sisa ± {time}",
  "Recent activity": "Aktivitas terbaru",
  "Latest messages from analysis and recovery jobs. Messages from the server are shown in English.": "Pesan terbaru dari proses analisis dan pemulihan. Pesan dari server tetap berbahasa Inggris.",
  "No activity yet": "Belum ada aktivitas",
  "Add your first domain to get started.": "Tambahkan domain pertama untuk mulai.",
  "Open jobs": "Buka proses",
  "Reading archive history": "Membaca riwayat arsip",
  "Selecting captures": "Memilih rekaman arsip",
  "Downloading files": "Mengunduh file",
  "Rebuilding website": "Menyusun ulang website",
  "Checking quality": "Memeriksa kualitas",
  "Packaging ZIP": "Membuat ZIP",
  "Finishing": "Menyelesaikan",

  // domains
  "All": "Semua",
  "Spam / parked risk": "Risiko spam / parkir",
  "Newest first": "Terbaru dulu",
  "Name (A–Z)": "Nama (A–Z)",
  "Most pages": "Halaman terbanyak",
  "Most captures": "Rekaman arsip terbanyak",
  "Oldest last capture": "Rekaman terakhir paling lama",
  "Spam content": "Konten spam",
  "Spam URLs": "URL spam",
  "Parked / for sale": "Diparkir / dijual",
  "Analyzing…": "Menganalisis…",
  "Recovering…": "Memulihkan…",
  "Files available until {date}": "File tersedia sampai {date}",
  "deleted {when}": "dihapus {when}",
  "Files expired": "File sudah dihapus",
  "Not analyzed yet": "Belum dianalisis",
  "Years since the first archive capture": "Jumlah tahun sejak rekaman arsip pertama",
  "Different designs or owners over time": "Desain atau pemilik berbeda dari waktu ke waktu",
  "Share of archived pages with at least one usable capture ({n} pages found)": "Persentase halaman arsip yang punya minimal satu rekaman yang bisa dipakai ({n} halaman ditemukan)",
  "{n}% recoverable": "{n}% bisa dipulihkan",
  "Best: {label}": "Terbaik: {label}",
  "Analysis of {name} started": "Analisis {name} dimulai",
  "{name} deleted": "{name} dihapus",
  "Analysis started for {n} domain(s)": "Analisis dimulai untuk {n} domain",
  "Recovery started for {n} domain(s)": "Pemulihan dimulai untuk {n} domain",
  "{n} domain(s) deleted": "{n} domain dihapus",
  "{n} skipped: {why}": "{n} dilewati: {why}",
  "not analyzed yet": "belum dianalisis",
  "a job is running": "ada proses yang berjalan",
  "a job is already active": "sudah ada proses aktif",
  "Analyze again": "Analisis ulang",
  "Delete domain": "Hapus domain",
  "Removes its jobs and files": "Menghapus semua proses dan file-nya",
  "Delete {name} and everything recovered for it?": "Hapus {name} beserta semua hasil pemulihannya?",
  "Every domain you manage, with its archive status and latest recovery.": "Semua domain yang dikelola, beserta status arsip dan hasil pemulihan terakhir.",
  "Add domains": "Tambah domain",
  "Sort": "Urutkan",
  "Search domains": "Cari domain",
  "Search": "Cari",
  "No domains match": "Tidak ada domain yang cocok",
  "No domains yet": "Belum ada domain",
  "Try a different filter.": "Coba filter lain.",
  "Add a domain to analyze its history in the Internet Archive.": "Tambahkan domain untuk menganalisis riwayatnya di Internet Archive.",
  "Select all on this page": "Pilih semua di halaman ini",
  "Domain": "Domain",
  "Status": "Status",
  "Score": "Nilai",
  "Age = years since the first archive capture. Versions = different designs or owners over time. Recoverable = share of archived pages that can be restored. Red/amber labels warn about spam or parked periods.":
    "Umur = tahun sejak rekaman arsip pertama. Versi = desain atau pemilik berbeda dari waktu ke waktu. Bisa dipulihkan = persentase halaman arsip yang bisa dipulihkan. Label merah/kuning = peringatan periode spam atau parkir.",
  "Latest result": "Hasil terakhir",
  "Select {name}": "Pilih {name}",
  "{n} captures · {from}–{to}": "{n} rekaman arsip · {from}–{to}",
  "Bulk actions": "Aksi massal",
  "Analyze": "Analisis",
  "Uses the recommended period of each domain. Domains not analyzed yet are skipped.": "Memakai periode rekomendasi tiap domain. Domain yang belum dianalisis dilewati.",
  "Recover (recommended)": "Pulihkan (rekomendasi)",
  "Delete": "Hapus",
  "Clear selection": "Batalkan pilihan",
  "{n} yr": "{n} thn",
  "{n} yrs": "{n} thn",
  "{n} version": "{n} versi",
  "{n} versions": "{n} versi",
  "{n} domain selected": "{n} domain dipilih",
  "{n} domains selected": "{n} domain dipilih",
  "Delete {n} domain and everything recovered for it?": "Hapus {n} domain beserta semua hasil pemulihannya?",
  "Delete {n} domains and everything recovered for them?": "Hapus {n} domain beserta semua hasil pemulihannya?",

  // before / after comparison
  "In the archive": "Di arsip",
  "Restored": "Hasil pulihan",
  "{n}% visually similar": "{n}% mirip secara visual",
  "Comparison view": "Tampilan perbandingan",
  "Slider": "Geser",
  "Side by side": "Berdampingan",
  "Move the comparison divider": "Geser pembatas perbandingan",

  // DomainOps Hub shell, dashboard and settings
  "Dashboard": "Dashboard",
  "Main": "Utama",
  "Domain tools": "Alat domain",
  "Recovery tools": "Alat pemulihan",
  "System": "Sistem",
  "Main navigation": "Navigasi utama",
  "Domain intelligence & recovery": "Riset & pemulihan domain",
  "Profile": "Profil",
  "Expand sidebar": "Lebarkan sidebar",
  "Collapse sidebar": "Ciutkan sidebar",
  "Job history": "Riwayat proses",
  "Downloads": "Unduhan",
  "Activity across Domain Drop Monitor, Wayback Recovery and Website Cloner.": "Aktivitas Domain Drop Monitor, Wayback Recovery, dan Website Cloner.",
  "Counts are refreshed at most once a minute": "Angka diperbarui paling sering sekali per menit",
  "Updated {when}": "Diperbarui {when}",
  "Domains discovered": "Domain ditemukan",
  "Auctions closing within 24 h": "Lelang tutup dalam 24 jam",
  "{n} active auctions": "{n} lelang aktif",
  "Buy Now available": "Buy Now tersedia",
  "Active, recently confirmed listings": "Listing aktif yang baru dikonfirmasi",
  "Active recovery jobs": "Pemulihan berjalan",
  "Completed recoveries": "Pemulihan selesai",
  "Failed jobs": "Proses gagal",
  "All tools": "Semua alat",
  "Website clones": "Clone website",
  "{n} running": "{n} berjalan",
  "Storage in use": "Penyimpanan terpakai",
  "System monitoring": "Pemantauan sistem",
  "Quick actions": "Aksi cepat",
  "Start Wayback Recovery": "Mulai Wayback Recovery",
  "Search domain drops": "Cari domain drop",
  "Start a website clone": "Mulai clone website",
  "Job status": "Status proses",
  "active": "aktif",
  "Latest messages from all tools. Messages from the server are shown in English.": "Pesan terbaru dari semua alat. Pesan dari server ditampilkan dalam bahasa Inggris.",
  "Search domain drops or add a domain to get started.": "Cari domain drop atau tambahkan domain untuk mulai.",
  "Start by analyzing a domain on the Dashboard.": "Mulai dengan menganalisis domain di Dashboard.",
  "Source health": "Kesehatan sumber",
  "Manage sources": "Kelola sumber",
  "Healthy": "Sehat",
  "Healthy (no changes)": "Sehat (tidak ada perubahan)",
  "Syncing": "Sinkronisasi",
  "Delayed": "Terlambat",
  "Disabled": "Nonaktif",
  "Not configured": "Belum diatur",
  "Authentication required": "Perlu autentikasi",
  "Rate limited": "Dibatasi provider",
  "Unavailable": "Tidak tersedia",
  "Manual import": "Impor manual",
  "Import failed": "Impor gagal",
  "Some feeds failing": "Sebagian feed bermasalah",
  "Configuration required": "Perlu konfigurasi",
  "Listings fresh": "Listing segar",
  "Listings stale": "Listing basi",
  "No active listings": "Tidak ada listing aktif",
  "Last successful sync": "Sync terakhir yang berhasil",
  "Last attempt": "Percobaan terakhir",
  "Success": "Berhasil",
  "Attempt": "Percobaan",
  "Newest listing seen {when}": "Listing terbaru terlihat {when}",
  "All tool settings in one place.": "Semua pengaturan alat di satu tempat.",
  "General": "Umum",
  "Signed in as {name}.": "Masuk sebagai {name}.",
  "Display": "Tampilan",
  "Language and theme are switched in the top bar and remembered in this browser. Domain Drop Monitor times use the time zone set in its settings.": "Bahasa dan tema diganti di bilah atas dan diingat di browser ini. Waktu Domain Drop Monitor memakai zona waktu di pengaturannya.",
  "Clone limits": "Batas clone",
  "Each clone starts with these values and can be adjusted on the clone form within the allowed range.": "Setiap clone memakai nilai ini dan bisa diubah di form clone dalam rentang yang diizinkan.",
  "Setting": "Pengaturan",
  "Default": "Bawaan",
  "Allowed range": "Rentang yang diizinkan",
  "Total download size": "Total ukuran unduhan",
  "Files per page": "File per halaman",
  "Largest file": "File terbesar",
  "File storage": "Penyimpanan file",
  "Clone ZIPs and working files are deleted {hours} h after the clone finishes (same setting as Wayback Recovery → Storage).": "ZIP dan file kerja clone dihapus {hours} jam setelah clone selesai (pengaturan yang sama dengan Wayback Recovery → Penyimpanan).",
  "API": "API",
  "Degraded": "Terganggu",
  "Database": "Database",
  "Job queue": "Antrean proses",
  "Queues": "Antrean",
  "Tasks waiting for a worker.": "Tugas yang menunggu worker.",
  "Jobs run in the API process (no separate queue).": "Proses berjalan di proses API (tanpa antrean terpisah).",
  "Jobs by status": "Proses per status",

  // User management / RBAC
  "User Management": "Manajemen User",
  "Users": "User",
  "Roles": "Role",
  "Audit log": "Log audit",
  "No access": "Tidak ada akses",
  "Ask the owner or an administrator for access to user management.": "Minta akses manajemen user ke owner atau administrator.",
  "Who can use the panel and what each person may do. Access is checked by the server on every request.": "Siapa yang bisa memakai panel dan apa yang boleh dilakukan. Akses dicek server di setiap permintaan.",
  "Create user": "Buat user",
  "User": "User",
  "Role": "Role",
  "Last login": "Login terakhir",
  "Actions": "Aksi",
  "you": "Anda",
  "Custom permissions": "Izin khusus",
  "custom": "khusus",
  "Active": "Aktif",
  "Never": "Belum pernah",
  "Edit role & permissions": "Ubah role & izin",
  "Reset password": "Reset password",
  "Disable user": "Nonaktifkan user",
  "Enable user": "Aktifkan user",
  "Disable {name}? They are signed out immediately.": "Nonaktifkan {name}? User langsung keluar dari semua sesi.",
  "You can only grant permissions you have": "Anda hanya bisa memberi izin yang Anda miliki",
  "Edit {name}": "Ubah {name}",
  "Start from a role, then add or remove single permissions. Highlighted items differ from the role.": "Pilih role, lalu tambah atau kurangi izin satu per satu. Yang ditandai berbeda dari role.",
  "Cancel": "Batal",
  "Save": "Simpan",
  "Saved": "Tersimpan",
  "Deleted": "Dihapus",
  "Username": "Username",
  "Initial password (10+ characters)": "Password awal (10+ karakter)",
  "Password changed; the user was signed out": "Password diganti; user dikeluarkan dari semua sesi",
  "Reset password for {name}": "Reset password {name}",
  "Share the new password through a private channel. All of the user's sessions end.": "Kirim password baru lewat jalur pribadi. Semua sesi user berakhir.",
  "Built-in roles are fixed. Create custom roles for other combinations.": "Role bawaan tetap. Buat role khusus untuk kombinasi lain.",
  "Create role": "Buat role",
  "built-in": "bawaan",
  "{n} users": "{n} user",
  "No permissions": "Tanpa izin",
  "Edit": "Ubah",
  "Delete role {name}?": "Hapus role {name}?",
  "Edit role": "Ubah role",
  "Name": "Nama",
  "ID": "ID",
  "Sign-ins, user and role changes, and settings changes. Passwords are never recorded.": "Login, perubahan user & role, dan perubahan pengaturan. Password tidak pernah dicatat.",
  "Nothing recorded yet": "Belum ada catatan",
  "When": "Kapan",
  "Who": "Siapa",
  "Action": "Aksi",
  "Details": "Detail",
  "Signed in": "Login",
  "Failed sign-in": "Login gagal",
  "Signed out": "Logout",
  "Changed own password": "Mengganti password sendiri",
  "Reset a password": "Reset password user",
  "Created a user": "Membuat user",
  "Changed a user's access": "Mengubah akses user",
  "Enabled a user": "Mengaktifkan user",
  "Disabled a user": "Menonaktifkan user",
  "Created a role": "Membuat role",
  "Changed a role": "Mengubah role",
  "Deleted a role": "Menghapus role",
  "Changed settings": "Mengubah pengaturan",
  "Changed a data source": "Mengubah sumber data",
  "Active users": "User aktif",
  "{n} accounts": "{n} akun",
  "Choose a tool from the menu": "Pilih alat dari menu",
  "Your account does not include the dashboard.": "Akun Anda tidak termasuk akses dashboard.",

  // ZIP cleanup
  "ZIP downloaded. The server copy is deleted {when}.": "ZIP sudah diunduh. Salinan di server dihapus {when}.",
  "ZIP downloaded — server files are deleted {when}": "ZIP sudah diunduh — file di server dihapus {when}",
  "The download finished, so the server copy is removed shortly to save space. The results stay here; Run again rebuilds the files.": "Unduhan selesai, jadi salinan di server segera dihapus agar hemat ruang. Hasil tetap tersimpan; Run again membangun ulang file.",
  "downloaded, deleted {when}": "sudah diunduh, dihapus {when}",
  "Delete files after a completed download": "Hapus file setelah unduhan selesai",
  "Recovery and clone files are removed this long after their ZIP was downloaded completely. 0 = keep until the maximum below.": "File recovery dan clone dihapus selama ini setelah ZIP-nya selesai diunduh. 0 = simpan sampai batas maksimal di bawah.",
  "Keep files at most": "Simpan file paling lama",
  "Also for ZIPs that are never downloaded. Results stay visible; Run again rebuilds the files.": "Berlaku juga untuk ZIP yang tidak pernah diunduh. Hasil tetap terlihat; Run again membangun ulang file.",
  "min": "menit",
  "Automatic file cleanup": "Pembersihan file otomatis",
  "ZIPs and working files of Wayback Recovery and Website Cloner are deleted after a completed download or when they expire.": "ZIP dan file kerja Wayback Recovery serta Website Cloner dihapus setelah unduhan selesai atau saat kedaluwarsa.",
  "Jobs with files on the server": "Job yang masih punya file di server",
  "Downloaded, waiting for deletion": "Sudah diunduh, menunggu dihapus",
  "Next deletion": "Penghapusan berikutnya",
  "Rule": "Aturan",
  "{m} min after download · max {h} h": "{m} menit setelah diunduh · maks. {h} jam",
  "A download is in progress; its files are kept until it ends.": "Ada unduhan yang sedang berjalan; file-nya disimpan sampai selesai.",

  // UI polish
  "Skip to content": "Lewati ke konten",
  "Dismiss": "Tutup",
  "Confirm": "Konfirmasi",
  "This cannot be undone.": "Tindakan ini tidak bisa dibatalkan.",
  "Please confirm to continue.": "Konfirmasi untuk melanjutkan.",
} as Record<string, string>;
